import React from "react";
import { useAuth } from "../providers/AuthProvider";
import { Link, useNavigate } from "react-router-dom";
import FormInput from "src/components/widgets/FormInput";
import PasswordInput from "src/components/widgets/PasswordInput";
import * as Yup from "yup";

import { setToLocalStorage, showSuccessToast } from "src/lib/utils";
import { Formik } from "formik";
import { loginFn } from "src/api/auth";
import { useMutation } from "@tanstack/react-query";

const Login = () => {
	const { setUser } = useAuth();
	const navigate = useNavigate();

	const initialValues = {
		email: "",
		password: "",
	};
	const validationSchema = Yup.object().shape({
		email: Yup.string().email("Please provide a valid email").required("Email is required"),
		password: Yup.string().required("Password is required"),
	});

	const { mutate, isLoading } = useMutation(loginFn, {
		onSuccess: ({ message, data }, { email }) => {
			showSuccessToast(message ?? "Logged in successfully");

			const user = data.user;

			if (!user?.is_otp_verified) {
				navigate("/otp-verification", { state: { email } });

				return;
			}

			setUser(user);

			const access_token = data.access_token;
			setToLocalStorage("access_token", access_token);
			navigate("/dashboard");
		},
	});

	return (
		<div className="loginForm tw-px-6 md:tw-px-10 tw-py-8">
			<div className="pageTitle">
				<h1>Welcome Back</h1>
				<p>Login to your account</p>
			</div>

			<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
				{({ values, handleChange, handleSubmit, errors }) => (
					<form onSubmit={handleSubmit} className="grid">
						<FormInput
							label="Email"
							name="email"
							type="email"
							placeholder="Email"
							value={values.email}
							onChange={handleChange}
							error={errors.email}
							autoComplete="off"
						/>

						<PasswordInput
							label="Password"
							name="password"
							type="password"
							placeholder="Password"
							value={values.password}
							onChange={handleChange}
							error={errors.password}
							autoComplete="off"
						/>

						<button type="submit" className="authButton" disabled={isLoading}>
							{isLoading ? "Loading..." : "Login"}
						</button>

						<p className="authFormText">
							Not registered? <Link to="/signup">Click here to Sign up</Link>
						</p>

						<br />

						<p className="authFormText">
							<Link to="/forgot-password">Forgot Password</Link>
						</p>
					</form>
				)}
			</Formik>
		</div>
	);
};

export default Login;
